'use client';

import { createContext, useContext } from 'react';
import { socialObjectToLinks } from '@/lib/socialIcons';

const CmsContext = createContext(null);

export function CmsProvider({ data, children }) {
  return <CmsContext.Provider value={data ?? null}>{children}</CmsContext.Provider>;
}

export function useCmsData() {
  return useContext(CmsContext);
}

/** Site settings from CMS with fallbacks. */
export function useSiteSettings() {
  const settings = useCmsData()?.site_settings;
  const phone = settings?.phone || '+380000000000';
  const phone2 = (settings?.phone_2 || '').trim();
  const social = settings?.social || {};
  // Prefer explicit social_links (even empty) — never revive the full legacy list.
  const socialLinks = Array.isArray(settings?.social_links)
    ? settings.social_links
    : socialObjectToLinks(social).map(({ icon, url, label }) => ({ icon, url, label }));

  const findSocialUrl = (icon) =>
    socialLinks.find((item) => item.icon === icon)?.url || social[icon] || '';

  const toTel = (value) => value.replace(/\s/g, '').replace(/^tel:/i, '');

  return {
    logo: settings?.logo || 'GRV',
    logoUrl: settings?.logo_url || '',
    phone,
    phoneTel: toTel(phone),
    phone2,
    phone2Tel: phone2 ? toTel(phone2) : '',
    email: settings?.email || 'info@grvbuild.ua',
    address: settings?.address || 'м. Луцьк, Волинська обл.',
    slogan: settings?.slogan || 'Будуємо сьогодні — створюємо майбутнє',
    shortDescription:
      settings?.short_description ||
      'Будуємо сьогодні — створюємо майбутнє. Якість, надійність та досвід у кожному проєкті.',
    workingHours: settings?.working_hours || '',
    copyright: settings?.copyright || '© 2024 GRV BUILD. Всі права захищені.',
    social,
    socialLinks,
    telegram: findSocialUrl('telegram'),
    viber: findSocialUrl('viber'),
    whatsapp: findSocialUrl('whatsapp'),
  };
}
